import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth-context.js';
import { initAnalytics, shutdownAnalytics, track } from './index.js';
import { matchRouteTemplate } from './route-template.js';

/**
 * Mount inside <AuthProvider> + <BrowserRouter>. Boots analytics once `me`
 * resolves and emits a page_view (with the matched route TEMPLATE) on every
 * navigation. Shuts down on sign-out.
 */
export function Analytics(): null {
  const { me } = useAuth();
  const meId = me?.id ?? null;
  const location = useLocation();
  const bootedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!meId) {
      if (bootedFor.current !== null) {
        shutdownAnalytics();
        bootedFor.current = null;
      }
      return;
    }
    const { template, jobId } = matchRouteTemplate(location.pathname);
    if (bootedFor.current !== meId) {
      if (bootedFor.current !== null) shutdownAnalytics();
      initAnalytics(meId, template);
      bootedFor.current = meId;
    }
    track.pageView(template, jobId ? { jobId } : undefined);
  }, [meId, location.pathname]);

  return null;
}
